<template>
  <div
    class="tours-container"
    :class="showList ? 'list' : ''"
    v-if="showResults && ((!showList && galleryItems?.length) || showList)"
  >
    <div class="tours-filter" v-if="showList">
      <div class="filter-group">
        <div class="item">
          <el-dropdown
            trigger="click"
            ref="locationDropdown"
            popper-class="filter-dropdown location"
            :teleported="false"
          >
            <div class="selector-container">
              <ElButton type="primary square">
                <Icons name="16px/location" />
                <div class="button-text">
                  <span>
                    {{
                      filterTours.filterField.locations.value?.length
                        ? filterTours.filterField.locations.value.join(', ')
                        : $t('select_destinations')
                    }}
                  </span>
                </div>
                <Icons name="16px/chevron_down" />
              </ElButton>
            </div>
            <template #dropdown>
              <UtilsFilterLocations
                @selectedLocation="
                  filterTours.filterField.locations.value = $event
                "
                :show-actions="true"
                @filter="filter(), $refs.locationDropdown.handleClose()"
              />
            </template>
          </el-dropdown>
        </div>
        <div class="item">
          <el-dropdown
            trigger="click"
            popper-class="filter-dropdown"
            :teleported="false"
            :hide-on-click="false"
            ref="durationDropdown"
          >
            <ElButton type="primary square">
              <Icons name="24px/clock" />
              <div class="button-text">
                <span>
                  {{ $t('duration') }}
                </span>
              </div>
            </ElButton>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  v-for="item in durationOptions"
                  :key="item.value"
                >
                  <ElCheckbox
                    class="landing-checkbox-rounded"
                    :model-value="isDurationSelected(item)"
                    @change="selectedDuration(item)"
                  >
                    <span class="body2">
                      {{ $t(item.label) }}
                    </span>
                  </ElCheckbox>
                </el-dropdown-item>
                <el-dropdown-item class="actions">
                  <ElButton
                    type="link dark"
                    @click="
                      ;(filterTours.where.estimated_duration.value = null),
                        filter(),
                        $refs.durationDropdown.handleClose()
                    "
                  >
                    {{ $t('clear') }}
                  </ElButton>
                  <ElButton
                    type="primary dark"
                    @click="filter(), $refs.durationDropdown.handleClose()"
                  >
                    {{ $t('apply') }}
                  </ElButton>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
        <div class="item">
          <el-dropdown
            trigger="click"
            popper-class="filter-dropdown"
            :teleported="false"
            :hide-on-click="false"
            ref="languagesDropdown"
          >
            <ElButton type="primary square">
              <Icons name="24px/translate" />
              <div class="button-text">
                <span>
                  {{ $t('langs') }}
                </span>
              </div>
            </ElButton>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  v-for="item in languages ?? []"
                  :key="item.iso_code"
                  class="item"
                >
                  <ElCheckbox
                    class="landing-checkbox-rounded"
                    :model-value="isLanguageSelected(item)"
                    @change="selectedLanguage(item)"
                  >
                    <span class="body2">
                      {{ $t(item.label) }}
                    </span>
                  </ElCheckbox>
                </el-dropdown-item>
                <el-dropdown-item class="actions">
                  <ElButton
                    type="link dark"
                    @click="
                      ;(filterTours.filterField.languages.value = []),
                        filter(),
                        $refs.languagesDropdown.handleClose()
                    "
                  >
                    {{ $t('clear') }}
                  </ElButton>
                  <ElButton
                    type="primary dark"
                    @click="filter(), $refs.languagesDropdown.handleClose()"
                  >
                    {{ $t('apply') }}
                  </ElButton>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
      <ElButton
        type="primary"
        class="button-filter"
        @click="openFilterDrawer()"
      >
        {{ width >= 1100 ? $t('filters') : $t('filter_and_sort') }}
        <Icons name="16px/filtering" />
      </ElButton>
    </div>
    <div class="tours-title">
      <div class="title-text">
        <span class="heading3" v-if="route.name === 'tours-id'">{{
          $t('similar_tours')
        }}</span>
        <span class="heading3" v-else-if="route.name === 'guides-id'">{{
          $t('guide_tours', { name: guide?.first_name ?? '' })
        }}</span>
        <span class="heading3" v-else>{{ $t('guided_tours') }}</span>
      </div>
      <div class="title-action" v-if="!showList">
        <ElButton type="link dark arrow" @click="$emit('allTours')"
          >{{ $t('all') }}<Icons name="16px/arrow_right"
        /></ElButton>
      </div>
      <div class="title-filter" v-else-if="showList">
        <ElButton
          :type="width >= 1100 ? 'primary dark' : 'icon dark'"
          @click="fullscreeMap()"
        >
          <span v-if="width >= 1100">{{ $t('map_view') }}</span>
          <Icons name="16px/map_white" />
        </ElButton>
        <ElSelect
          v-if="width >= 1100"
          v-model="sortBy"
          :autocomplete="true"
          class="!w-full landing-select no-background"
          :placeholder="$t('sort_by')"
          @change="filter()"
          :fallback-placements="['top', 'bottom']"
          :popper-options="getSelectPopperOptions()"
          popper-class="custom-selector"
        >
          <el-option
            v-for="item in sortByOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </ElSelect>
      </div>
    </div>
    <div class="tours-gallery">
      <div class="gallery-container">
        <carousel
          v-if="!showList"
          :items-to-scroll="width <= 1100 ? 1 : 1"
          :breakpoints="{
            0: {
              itemsToShow: 1.4,
              snapAlign: 'start'
            },
            700: {
              itemsToShow: 2.4,
              snapAlign: 'start'
            },
            1200: {
              itemsToShow: 3,
              snapAlign: 'start'
            },
            1450: {
              itemsToShow: 4,
              snapAlign: 'start'
            },
            1600: {
              itemsToShow: 4,
              snapAlign: 'start'
            },
            1900: {
              itemsToShow: 4.5,
              snapAlign: 'start'
            }
          }"
        >
          <slide
            v-for="item in galleryItems"
            :key="item.uuid"
            @click="router.push(`/tours/${item.uuid}`)"
          >
            <div class="gallery">
              <div
                class="image"
                :class="item.cover || item.image ? 'with-image' : ''"
              >
                <div
                  class="exclusive"
                  v-if="getAuthUser()?.value?.uuid && !item.user_can_purchase"
                >
                  <span class="small">
                    {{ $t('exclusive') }}
                  </span>
                </div>
                <video
                  v-if="item.cover"
                  :src="item.cover"
                  autoplay
                  muted
                  loop
                />
                <img v-else-if="item.image" :src="item.image" loading="lazy" />
                <img
                  v-else
                  src="/logos/PALC_Marque_Gold.svg"
                  alt="logo"
                  class="logo-img"
                />
              </div>
              <div class="gallery-title">
                <span class="heading6">{{ item.title }}</span>
              </div>
              <div class="gallery-location">
                <span class="caption" v-if="item.location">{{
                  item.location
                }}</span>
              </div>
            </div>
          </slide>

          <template #addons>
            <navigation />
            <pagination />
          </template>
        </carousel>
        <ElRow
          v-infinite-scroll="loadMoreItems"
          :gutter="20"
          v-else-if="showList && galleryItems?.length"
        >
          <ElCol
            :span="24"
            :sm="12"
            :md="12"
            :lg="width <= 1600 ? 8 : 6"
            :xl="6"
            class="gallery"
            v-for="item in galleryItems"
            :key="item.uuid"
            @click="router.push(`/tours/${item.uuid}`)"
          >
            <div
              class="image"
              :class="item.cover || item.image ? 'with-image' : ''"
            >
              <div
                class="exclusive"
                v-if="getAuthUser()?.value?.uuid && !item.user_can_purchase"
              >
                <span class="small">
                  {{ $t('exclusive') }}
                </span>
              </div>
              <video v-if="item.cover" :src="item.cover" autoplay muted loop />
              <img v-else-if="item.image" :src="item.image" loading="lazy" />
              <img
                v-else
                src="/logos/PALC_Marque_Gold.svg"
                alt="logo"
                class="logo-img"
              />
            </div>
            <div class="gallery-title">
              <span class="heading6">{{ item.title }}</span>
            </div>
            <div class="gallery-location" v-if="!showReservation">
              <span class="caption" v-if="item.location">{{
                item.location
              }}</span
              ><span class="caption" v-if="item.date">{{ item.date }}</span>
            </div>
            <div class="gallery-actions" v-if="showReservation">
              <ElButton
                type="secondary dark"
                @click.stop.prevent="$emit('addToItinerary', item)"
              >
                {{ $t('add_to_itinerary') }}
                <Icons
                  name="16px/plus"
                  class="ml-2"
                  style="margin-right: -8px"
                />
              </ElButton>
            </div>
          </ElCol>
        </ElRow>
        <div
          class="content-empty"
          v-if="showList && galleryItems?.length === 0"
        >
          <div class="empty-title">
            <span class="heading3">
              {{ $t('we_couldn_t_find_any_exact_matches_for_that_search') }}.
              {{ $t('try') }}
              <span
                class="heading3 underline cursor-pointer"
                @click="filterDrawer = true"
              >
                {{ $t('changing_or_removing_some_of_your_filters') }} </span
              >,&nbsp;{{ $t('or') }}
              <span
                class="heading3 underline cursor-pointer"
                @click="goToDonatella()"
                >{{ $t('speak_to_donatella') }}</span
              >
              {{ $t('for_inspiration') }}
            </span>
          </div>
          <div class="empty-icon">
            <Icons name="24px/heart_filled" />
          </div>
        </div>
      </div>
    </div>
    <UtilsListMap v-if="showList" :items="galleryItems" ref="tourMap" />
    <UtilsFooter v-if="showList" />
    <el-drawer v-model="filterDrawer" direction="rtl" class="left-drawer">
      <template #header>
        <span class="heading3">{{ $t('filter_tours') }}</span>
      </template>
      <template #default>
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1" v-if="width < 1100">
            <template #title>
              <span class="body2-strong">
                {{ $t('sort_by') }}
              </span>
              <Icons
                name="16px/minus"
                class="filter-icon"
                v-if="activeNames.includes('1')"
              />
              <Icons name="16px/plus" class="filter-icon" v-else />
            </template>
            <ElSelect
              v-model="sortBy"
              :autocomplete="true"
              class="!w-full landing-select"
              :placeholder="$t('sort_by')"
              @change="$emit('input')"
              :fallback-placements="['top', 'bottom']"
              :popper-options="getSelectPopperOptions()"
              popper-class="custom-selector"
            >
              <el-option
                v-for="item in sortByOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </ElSelect>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template #title>
              <span class="body2-strong">
                {{ $t('specialties') }}
              </span>
              <Icons
                name="16px/minus"
                class="filter-icon"
                v-if="activeNames.includes('2')"
              />
              <Icons name="16px/plus" class="filter-icon" v-else />
            </template>
            <div class="form-vertical-list">
              <div
                v-for="specialty in specialties ?? []"
                :key="specialty.value"
                class="item"
              >
                <ElCheckbox
                  class="landing-checkbox-rounded"
                  v-model="specialty.selected"
                  @change="selectedSpecialty(specialty)"
                />
                <span class="body2">
                  {{ specialty.label }}
                </span>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="3">
            <template #title>
              <span class="body2-strong">
                {{ $t('kids_friendly') }}
              </span>
              <Icons
                name="16px/minus"
                class="filter-icon"
                v-if="activeNames.includes('3')"
              />
              <Icons name="16px/plus" class="filter-icon" v-else />
            </template>
            <ElSwitch
              class="landing-switch"
              :model-value="filterTours.where.kids_friendly.value === true"
              @change="filterTours.where.kids_friendly.value = $event"
            />
          </el-collapse-item>
          <el-collapse-item name="4">
            <template #title>
              <span class="body2-strong">
                {{ $t('accessibility_options') }}
              </span>
              <Icons
                name="16px/minus"
                class="filter-icon"
                v-if="activeNames.includes('4')"
              />
              <Icons name="16px/plus" class="filter-icon" v-else />
            </template>
            <div class="form-vertical-list">
              <div
                v-for="option in accessibilityOptions ?? []"
                :key="option.value"
                class="item"
              >
                <ElCheckbox
                  class="landing-checkbox-rounded"
                  v-model="option.selected"
                  @change="selectedAccessibilityOption(option)"
                />
                <span class="body2">
                  {{ option.label }}
                </span>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="5">
            <template #title>
              <span class="body2-strong">
                {{ $t('max_capacity') }}
              </span>
              <Icons
                name="16px/minus"
                class="filter-icon"
                v-if="activeNames.includes('5')"
              />
              <Icons name="16px/plus" class="filter-icon" v-else />
            </template>

            <div class="form-vertical-list">
              <div class="item">
                <ElInputNumber
                  class="landing-input is-number body2-strong"
                  type="number"
                  step="1"
                  min="0"
                  v-model="filterTours.where.max_capacity.value"
                />
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </template>
      <template #footer>
        <ElButton type="link dark" @click="resetFilter()" :loading="loading">
          {{ $t('clear') }}
        </ElButton>
        <ElButton type="primary dark" @click="filter()" :loading="loading">
          <span>{{ $t('show_tours') }}</span>
        </ElButton>
      </template>
    </el-drawer>
  </div>
</template>

<script>
import moment from 'moment'
import 'moment/dist/locale/es'
import 'moment/dist/locale/en-gb'
import 'moment/dist/locale/fr'
import 'moment/dist/locale/de'
import 'moment/dist/locale/sv'
import 'moment/dist/locale/ar'
import { ElCheckbox, ElLoading, ElMessageBox } from 'element-plus'
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'Tours',
  props: {
    showList: {
      type: Boolean,
      required: false,
      default: false
    },
    showReservation: {
      type: Boolean,
      required: false,
      default: false
    },
    tour: {
      type: Object,
      default: () => {}
    },
    guide: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tours: null,
      loadingDialog: null,
      loading: false,
      filterExists: false,
      filterDrawer: false,
      filterTours: {
        where: {
          uuid: {
            column: 'UUID',
            operator: 'NEQ',
            value: ''
          },
          estimated_duration: {
            column: 'ESTIMATED_DURATION',
            operator: '',
            value: null
          },
          kids_friendly: {
            column: 'KIDS_FRIENDLY',
            operator: 'EQ',
            value: ''
          },
          max_capacity: {
            column: 'MAX_CAPACITY',
            operator: 'LTE',
            value: null
          }
        },
        guide: {
          uuid: {
            column: 'UUID',
            value: ''
          }
        },
        filterField: {
          name: {
            value: ''
          },
          location: {
            value: ''
          },
          locations: {
            value: ''
          },
          orderForList: {
            value: ''
          },
          specialties: {
            value: ''
          },
          languages: {
            value: []
          },
          accesibilityOptions: {
            value: []
          }
        }
      },
      priceFilterMin: ref(''),
      priceFilterMax: ref(''),
      priceFilter: ref([0, 50000]),
      activeNames: ['1', '2', '3', '4', '5'],
      markerSelected: null,
      showResults: false,
      specialties: getSpecialties().map((specialty) => {
        return { ...specialty, selected: false }
      }),
      accessibilityOptions: getAccessibilities().map((option) => {
        return { ...option, selected: false }
      }),
      totalPages: null,
      currentPage: null,
      page: 1,
      sortBy: 'NAME'
    }
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation
  },
  setup() {
    const { width, height } = useBreakpoints()
    const { t } = useI18n()
    const { $sentry } = useNuxtApp()
    const router = useRouter()
    const route = useRoute()
    const config = useRuntimeConfig()

    const initialVariables = []

    let objectToReturn = {
      width,
      height,
      t,
      router,
      route,
      $sentry,
      config,
      languages: getLanguagesLanding()
    }
    for (const variable of initialVariables) {
      objectToReturn = Object.assign(objectToReturn, variable)
    }

    return objectToReturn
  },
  computed: {
    language() {
      return getAuthUser()?.value?.language
        ? getAuthUser()?.value?.language
        : this.$i18n.locale
    },
    galleryItems() {
      if (this.tours?.getAllTours?.data?.length) {
        return this.tours.getAllTours.data.map((tour) => {
          return {
            uuid: tour.uuid,
            type: 'tour',
            title:
              this.$i18n.locale === 'es'
                ? tour.name_es
                : this.$i18n.locale === 'en'
                ? tour.name_en
                : this.$i18n.locale === 'fr'
                ? tour.name_fr
                : this.$i18n.locale === 'de'
                ? tour.name_de
                : this.$i18n.locale === 'sv'
                ? tour.name_sv
                : this.$i18n.locale === 'ar'
                ? tour.name_ar
                : tour.name,
            cover: tour.coverVideo?.url ?? null,
            image: tour.mainImage?.url ?? null,
            location: tour?.location?.name ?? null,
            user_can_purchase: tour.user_can_purchase,
            short_description:
              this.$i18n.locale === 'es'
                ? tour.short_description_es
                : this.$i18n.locale === 'en'
                ? tour.short_description_en
                : this.$i18n.locale === 'fr'
                ? tour.short_description_fr
                : this.$i18n.locale === 'de'
                ? tour.short_description_de
                : this.$i18n.locale === 'sv'
                ? tour.short_description_sv
                : this.$i18n.locale === 'ar'
                ? tour.short_description_ar
                : tour.short_description,
            price: tour.price,
            price_type: tour.price?.type.toLowerCase() ?? null,
            currency: getAuthUser()?.value?.currency ?? 'usd',
            duration: this.getDuration(tour.estimated_duration ?? 0),
            coordinates: tour?.location?.address
              ? {
                  lng: tour.location.address.longitude,
                  lat: tour.location.address.latitude
                }
              : null
          }
        })
      }
      return []
    },
    durationOptions() {
      return [
        {
          value: 30,
          operator: 'LTE',
          label: this.$t('up_to_30_minutes')
        },
        {
          value: 60,
          operator: 'EQ',
          label: this.$t('1_hour')
        },
        {
          value: {
            from: 60,
            to: 120
          },
          operator: 'BETWEEN',
          label: this.$t('1_to_2_hours')
        },
        {
          value: 120,
          operator: 'GTE',
          label: this.$t('more_than_2_hours')
        }
      ]
    },
    sortByOptions() {
      return [
        {
          value: 'NAME',
          label: this.$t('name')
        },
        {
          value: 'ESTIMATED_DURATION',
          label: this.$t('duration')
        }
      ]
    }
  },
  mounted() {
    if (localStorage.getItem('filterTours')) {
      const filterTours = JSON.parse(localStorage.getItem('filterTours'))
      if (filterTours.guide?.uuid) {
        this.filterTours.guide.uuid = filterTours.guide.uuid
        localStorage.removeItem('filterTours')
      }
    }
    this.getTours()
  },
  methods: {
    async getTours(refetch = false) {
      try {
        this.loadingDialog = ElLoading.service({
          fullscreen: true,
          background: '#F7F7F7',
          svg: useLoaderSvg(),
          svgViewBox: useLoaderSvgViewBox()
        })
        if (this.route.name === 'tours-id') {
          this.filterTours.filterField.location.value =
            this.tour?.location?.name
          this.filterTours.where.uuid.value = this.tour?.uuid
        }
        if (this.route.name === 'guides-id' && this.guide?.uuid) {
          this.filterTours.guide.uuid.value = this.guide.uuid
        }
        if (this.showList && this.sortBy === 'NAME') {
          this.filterTours.filterField.orderForList.value = true
        } else {
          this.filterTours.filterField.orderForList.value = false
        }
        const tours = await apolloTours(
          {
            sortBy: this.showList
              ? this.sortBy !== 'NAME'
                ? this.sortBy
                : ''
              : 'CREATED_AT',
            sortDesc: this.showList ? '' : false,
            search: null,
            page: 1,
            first: this.showList ? 500 : 8
          },
          true,
          this.filterTours,
          refetch ? 'network-only' : null
        )
        if (!this.showList) {
          this.tours = tours
        } else {
          const data = tours?.getAllTours?.data
          this.tours = {
            getAllTours: {
              data: (this.tours?.getAllTours?.data ?? [])
                .concat(data)
                .reduce(
                  (unique, item) =>
                    unique.find((i) => i.uuid === item.uuid)
                      ? unique
                      : [...unique, item],
                  []
                ),
              paginatorInfo: tours?.getAllTours?.paginatorInfo
            }
          }
          this.totalPages = tours?.getAllTours?.paginatorInfo?.lastPage
          this.currentPage = tours?.getAllTours?.paginatorInfo?.currentPage
        }
        this.customKey = setCustomKeyVariable()
      } catch (err) {
        this.$showError(err, this.t)
        this.$sentry(err, 'getTours')
      } finally {
        this.$emit('calculateOffset')
        this.loadingDialog.close()
        this.showResults = true
      }
    },
    async loadMoreItems() {
      if (
        this.page === this.currentPage &&
        this.currentPage < this.totalPages
      ) {
        this.page++
        this.getTours(true)
      }
    },
    resetFilter() {
      this.tours = {
        getAllTours: {
          data: [],
          paginatorInfo: {}
        }
      }
      this.filterTours = {
        where: {
          uuid: {
            column: 'UUID',
            operator: 'NEQ',
            value: ''
          },
          estimated_duration: {
            column: 'ESTIMATED_DURATION',
            operator: '',
            value: null
          },
          kids_friendly: {
            column: 'KIDS_FRIENDLY',
            operator: 'EQ',
            value: ''
          },
          max_capacity: {
            column: 'MAX_CAPACITY',
            operator: 'LTE',
            value: null
          }
        },
        guide: {
          uuid: {
            column: 'UUID',
            value: ''
          }
        },
        filterField: {
          name: {
            value: ''
          },
          location: {
            value: ''
          },
          locations: {
            value: ''
          },
          orderForList: {
            value: ''
          },
          specialties: {
            value: ''
          },
          languages: {
            value: []
          },
          accesibilityOptions: {
            value: []
          }
        }
      }
      this.currentPage = null
      this.page = 1
      this.priceFilterMin = ''
      this.priceFilterMax = ''
      this.priceFilter = [0, 50000]
      this.filterExists = false
      this.getTours(true)
    },
    filter() {
      this.tours = {
        getAllTours: {
          data: [],
          paginatorInfo: {}
        }
      }
      this.filterDrawer = false
      this.filterExists = true
      this.currentPage = null
      this.page = 1
      if (this.priceFilterMin || this.priceFilterMax) {
        this.filterTours.filterField.price.value = {
          min: parseInt(this.priceFilterMin ?? 0) * 100,
          max: parseInt(this.priceFilterMax ?? 50000) * 100
        }
      }
      this.getTours(true)
    },
    changePriceRangeFilter(event) {
      if (event[0] !== null && event[1] !== null) {
        this.priceFilterMin = event[0] ?? 0
        this.priceFilterMax = event[1] ?? 50000
      } else if (event[0] && event[1] === null) {
        this.priceFilterMin = parseInt(event[0])
        this.priceFilterMax = this.priceFilterMax ? this.priceFilterMax : 50000
        this.priceFilter = [this.priceFilterMin, this.priceFilterMax]
      } else if (event[0] === null && event[1]) {
        this.priceFilterMin = this.priceFilterMin ? this.priceFilterMin : 0
        this.priceFilterMax = parseInt(event[1])
        this.priceFilter = [this.priceFilterMin, this.priceFilterMax]
      }
    },
    fullscreeMap() {
      this.$refs.tourMap.fullscreen()
    },
    getDuration(duration) {
      // Calcula las horas y los minutos
      const hours = Math.floor(duration / 60)
      const minutes = duration % 60

      // Si no hay horas ni minutos, devolver un mensaje como "0 minutos" o vacío
      if (hours === 0 && minutes === 0)
        return `0 ${this.$t('minutes').toLowerCase()}`

      // Construir el formato dependiendo de si hay horas o minutos
      let result = ''

      if (hours > 0) {
        result += `${hours} ${
          hours > 1
            ? this.$t('hours').toLowerCase()
            : this.$t('hour').toLowerCase()
        }`
      }

      if (minutes > 0) {
        if (result) result += ' ' // Añade un espacio si ya hay horas
        result += `${minutes} ${
          minutes > 1
            ? this.$t('minutes').toLowerCase()
            : this.$t('minute').toLowerCase()
        }`
      }

      return result
    },
    viewGuideTours() {
      localStorage.setItem(
        'filterTours',
        JSON.stringify({
          guide: {
            uuid: {
              column: 'UUID',
              value: this.guide.uuid
            }
          }
        })
      )
      this.router.push('/tours')
    },
    selectedSpecialty(specialty) {
      this.specialties = this.specialties.map((i) => {
        if (specialty.value === i.value) {
          return {
            ...i,
            selected: i.selected ? true : false
          }
        }
        return i
      })
      this.filterTours.filterField.specialties.value =
        this.specialties
          .filter((i) => i.selected)
          .map((i) => i.value.toLowerCase()) ?? []
    },
    selectedAccessibilityOption(option) {
      this.accessibilityOptions = this.accessibilityOptions.map((i) => {
        if (option.value === i.value) {
          return {
            ...i,
            selected: i.selected ? true : false
          }
        }
        return i
      })
      this.filterTours.filterField.accesibilityOptions.value =
        this.accessibilityOptions
          .filter((i) => i.selected)
          .map((i) => i.value.toLowerCase()) ?? []
    },
    isDurationSelected(item) {
      return JSON.stringify(this.filterTours.where.estimated_duration.value) ===
        JSON.stringify(item.value)
        ? true
        : false
    },
    selectedDuration(item) {
      const selected = this.isDurationSelected(item)
      if (selected) {
        this.filterTours.where.estimated_duration.value = null
        this.filterTours.where.estimated_duration.operator = ''
      } else {
        this.filterTours.where.estimated_duration.value = item.value
        this.filterTours.where.estimated_duration.operator = item.operator
      }
    },
    isLanguageSelected(item) {
      return this.filterTours.filterField.languages.value?.length
        ? this.filterTours.filterField.languages.value.find(
            (i) => i === item.name.toLowerCase()
          )
          ? true
          : false
        : false
    },
    selectedLanguage(item) {
      const selected = this.isLanguageSelected(item)
      if (selected) {
        this.filterTours.filterField.languages.value =
          this.filterTours.filterField.languages.value.filter(
            (i) => i !== item.name.toLowerCase()
          )
      } else {
        this.filterTours.filterField.languages.value.push(
          item.name.toLowerCase()
        )
      }
    },
    openFilterDrawer() {
      this.filterDrawer = true
      if (this.width >= 1100 && !this.activeNames.find((i) => i === '2')) {
        this.activeNames.push('2')
      }
    }
  }
})
</script>

<style scoped lang="scss">
.tours-container:not(.list) {
  @media (min-width: 1100px) {
    padding: 40px 0 60px 0;
  }
  @media (max-width: 1100px) {
    padding: 40px 0 60px 0;
  }
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: left;
  background-color: var(--brand-off-white);
  .tours-title {
    width: 100%;
    text-align: left;
    margin-bottom: 24px;
    display: block;
    position: relative;
    @media (min-width: 1100px) {
      padding-left: 96px;
      padding-right: 96px;
    }
    @media (max-width: 1100px) {
      padding-left: 24px;
      padding-right: 24px;
    }
    .title-text {
      display: inline-block;
      .heading3 {
        color: var(--brand-off-black);
      }
    }
    .title-action {
      float: right;
      display: inline-block;
      position: relative;
      top: 6px;
      i {
        margin-left: 4px;
      }
    }
  }
  .tours-gallery {
    overflow-x: hidden;
    white-space: nowrap;
    text-align: left;
    width: 100%;
    max-width: 100vw;
    .gallery-container {
      @media (min-width: 1100px) {
        padding-left: 96px;
        padding-right: 96px;
      }
      @media (max-width: 1100px) {
        padding-left: 24px;
        padding-right: 24px;
      }
      .carousel__slide {
        @media (min-width: 1100px) {
          height: 374px;
        }
        @media (max-width: 1100px) {
          height: 325px;
        }
        align-items: flex-start;
        padding-right: 16px;
      }
      .gallery {
        cursor: pointer;
        @media (min-width: 1100px) {
          height: 374px;
        }
        @media (max-width: 1100px) {
          height: 325px;
        }
        width: 100%;
        display: inline-block;
        vertical-align: top;
        text-align: left;
        .image {
          @media (min-width: 1100px) {
            height: 288px;
          }
          @media (max-width: 1100px) {
            height: 241px;
          }
          .exclusive {
            display: flex;
            height: 32px;
            padding: 8px 12px;
            position: absolute;
            right: 24px;
            top: 8px;
            border-radius: 16px;
            background: var(--tins-light-2);
          }
          &.with-image {
            img,
            video {
              object-fit: cover;
              border-radius: 3px;
              width: 100%;
              height: 100%;
            }
          }
          &:not(.with-image) {
            @media (min-width: 1100px) {
              height: 288px;
            }
            @media (max-width: 1100px) {
              height: 241px;
            }
            background-color: var(--action-hover);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 3px;
            img {
              height: 120px;
              width: 171px;
            }
          }
        }
        .gallery-title {
          margin-top: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .heading6 {
            color: var(--brand-off-black);
          }
        }
        .gallery-location {
          margin-top: 8px;
          height: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .gallery-price {
          margin-top: 4px;
          height: 16px;
        }
      }
    }
  }
}

.tours-container.list {
  padding: 0 0 0 0;
  background-color: var(--brand-white);
  .tours-filter {
    background-color: var(--brand-off-white);
    margin-top: -20px;
    padding-bottom: 24px;
    position: relative;
    @media (min-width: 1100px) {
      padding-left: 96px;
      padding-right: 96px;
    }
    @media (max-width: 1100px) {
      padding-left: 24px;
      padding-right: 24px;
    }
    &.open {
      padding-bottom: 360px !important;
    }
    .filter-group {
      @media (min-width: 1100px) {
      }
      @media (max-width: 1100px) {
        display: flex;
        flex-wrap: wrap;
      }
      .item {
        @media (min-width: 1100px) {
          display: inline-block;
          &:not(:last-of-type) {
            margin-right: 6px;
          }
        }
        @media (max-width: 1100px) {
          flex: 0 0 25%;
          margin: 0 8px 8px 0;
        }
        .el-dropdown {
          .selector-container {
            .el-button {
              i {
                display: inline-block;
                &:nth-of-type(1) {
                  margin-right: 8px;
                }
                &:nth-of-type(2) {
                  margin-left: 8px;
                  margin-right: -4px;
                }
              }
              .button-text {
                max-width: 250px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                .body2 {
                  color: var(--brand-off-black);
                  display: inline-block;
                  margin-right: 8px;
                }
              }
            }
          }
          :deep(.filter-dropdown) {
            width: 288px;
            background-color: var(--brand-off-white);
            border: 1px solid transparent !important;
            box-shadow: 0 0 0 0 !important;
            .el-scrollbar {
              .el-dropdown__list {
                .el-dropdown-menu {
                  padding: 16px;
                  background-color: var(--brand-off-white);
                  .el-dropdown-menu__item {
                    padding-left: 0 !important;
                    padding-right: 0 !important;
                    &:hover,
                    &:focus {
                      background-color: transparent !important;
                    }
                    &:not(:last-of-type) {
                      margin-bottom: 16px;
                    }
                    .el-checkbox {
                      margin-right: 8px;
                    }
                    .body2 {
                      color: var(--brand-off-black);
                    }

                    .first-block {
                      width: calc(40% - 2px);
                      margin-right: 2px;
                      white-space: normal;
                      span {
                        display: block;
                        &:nth-of-type(1) {
                          color: var(--brand-off-black);
                        }
                        &:nth-of-type(2) {
                          color: var(--brand-off-black);
                        }
                      }
                    }
                    .second-block {
                      text-align: right;
                      width: calc(50% - 2px);
                    }

                    &.actions {
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    }
                  }
                }
              }
            }
            .el-popper__arrow {
              display: none;
            }
            &.location {
              width: 442px !important;
              padding: 8px 24px 32px 24px;
            }
            &.accommodation-type {
              width: 511px !important;
              padding: 16px 24px 32px 24px;
            }
          }
        }
        :deep(.landing-date-range) {
          position: relative;
          top: 34px;
          margin-top: -34px;
          width: 400px !important;
        }
      }
    }
    .button-filter {
      i {
        margin-left: 8px;
        margin-right: -4px;
      }
      @media (min-width: 1100px) {
        position: absolute;
        right: 96px;
        top: 0;
      }
    }
  }
  .tours-title {
    width: 100%;
    text-align: left;
    margin-bottom: 24px;
    display: block;
    position: relative;
    padding-top: 40px;
    @media (min-width: 1100px) {
      padding-left: 96px;
      padding-right: 96px;
    }
    @media (max-width: 1100px) {
      padding-left: 24px;
      padding-right: 24px;
    }
    .title-text {
      display: inline-block;
      .el-button {
        margin-right: 16px;
        position: relative;
        top: -8px;
      }
      .heading3 {
        color: var(--brand-off-black);
      }
    }
    .title-action {
      float: right;
      display: inline-block;
      position: relative;
      top: 6px;
      i {
        margin-left: 4px;
      }
    }
    .title-filter {
      @media (min-width: 700px) {
        float: right;
        display: inline-block;
        position: relative;
        top: 6px;
        .el-button {
          &:first-of-type {
            margin-right: 8px;
            position: relative;
            display: inline-flex;
            align-items: center;
            justify-content: flex-start;
            i {
              margin-left: 8px;
              margin-right: 0 !important;
            }
          }
        }
        .el-select {
          width: 200px !important;
          display: inline-block;
        }
      }
      @media (max-width: 700px) {
        display: inline-block;
        float: right;
        .el-button {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 0 !important;
        }
      }
    }
  }
  .tours-gallery {
    @media (min-width: 1100px) {
      padding-bottom: 60px;
    }
    @media (max-width: 1100px) {
      padding-bottom: 60px;
    }
    .gallery-container {
      @media (min-width: 1100px) {
        padding-left: 96px;
        padding-right: 96px;
      }
      @media (max-width: 1100px) {
        padding-left: 24px;
        padding-right: 24px;
      }
      .gallery {
        cursor: pointer;
        @media (min-width: 1100px) {
          height: 520px;
        }
        @media (max-width: 1100px) {
          height: 345px;
        }
        .image {
          background-size: cover !important;
          background-repeat: no-repeat;
          width: 100%;
          @media (min-width: 1100px) {
            height: 395px;
          }
          @media (max-width: 1100px) {
            height: 241px;
          }
          position: relative;
          .exclusive {
            display: flex;
            height: 32px;
            padding: 8px 12px;
            position: absolute;
            right: 16px;
            top: 8px;
            border-radius: 16px;
            background: var(--tins-light-2);
          }
          &.with-image {
            img,
            video {
              object-fit: cover;
              border-radius: 3px;
              width: 100%;
              height: 100%;
            }
          }
          &:not(.with-image) {
            @media (min-width: 1100px) {
              height: 395px;
            }
            @media (max-width: 1100px) {
              height: 241px;
            }
            background-color: var(--action-hover);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 3px;
            img {
              height: 120px;
              width: 171px;
            }
          }
        }
        .gallery-title {
          margin-top: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .heading6 {
            color: var(--brand-off-black);
          }
        }
        .gallery-location {
          margin-top: 8px;
          height: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .gallery-price {
          margin-top: 4px;
          height: 16px;
        }
        .gallery-actions {
          margin-top: 4px;
        }
      }
    }
  }
}

:deep(.el-overlay) {
  .left-drawer {
    .el-drawer__body {
      .form-name {
        padding: 24px 0 24px 0;
      }
      .el-collapse {
        margin-top: 32px;
        margin-bottom: 32px;
        border: 0 !important;
        .el-collapse-item {
          border: 0 !important;
          .el-collapse-item__header {
            background-color: var(--brand-off-white) !important;
            border: 0 !important;
            position: relative;
            i.el-icon {
              svg {
                display: none;
              }
            }
            i.filter-icon {
              position: absolute;
              right: 0 !important;
            }
          }
          .el-collapse-item__wrap {
            border-bottom: 1px solid var(--brand-white) !important;
            .el-collapse-item__content {
              background-color: var(--brand-off-white) !important;
              .form-location {
                padding: 16px 0 16px 0;
              }
              .form-countries {
                display: flex;
                flex-wrap: wrap;
                @media (min-width: 1100px) {
                  justify-content: flex-start;
                }
                @media (max-width: 1100px) {
                  width: 100%;
                  justify-content: flex-start;
                }
                .country {
                  cursor: pointer;
                  height: 130px;
                  width: 130px;
                  &:not(:last-of-type) {
                    margin-right: 16px;
                  }
                  vertical-align: top;
                  img {
                    background-size: cover !important;
                    background-repeat: no-repeat;
                    width: 130px;
                    height: 130px;
                    border-radius: 50%;
                  }
                }
              }
              .form-price {
                padding: 16px 0 16px 0;
              }
              .form-price-input-from,
              .form-price-input-to {
                width: calc(50% - 4px);
                display: inline-block;
              }

              .form-price-input-from {
                margin-right: 8px;
              }
              .form-vertical-list {
                max-height: 300px;
                overflow-y: auto;
                .item {
                  display: flex;
                  span.body2 {
                    position: relative;
                    top: 8px;
                    margin-left: 8px;
                  }

                  padding-top: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>